// Barrel — re-exports everything from the split domain files.
// 466 files import from 'Constants/constants'; this keeps them all working unchanged.
// Split from the original 5,833-line constants.js (see git history).

import { core } from './Sections/core'
import { api } from './Sections/api'
import { paths } from './Sections/paths'
import { auth } from './Sections/auth'
import { ui } from './Sections/ui'
import { tabs } from './Sections/tabs'
import { inputs } from './Sections/inputs'
import { statuses } from './Sections/statuses'
import { modules } from './Sections/modules'
import { choices } from './Sections/choices'

export const constants = {
    ...core,
    ...api,
    ...paths,
    ...auth,
    ...ui,
    ...tabs,
    ...inputs,
    ...statuses,
    ...modules,
    ...choices,
}

export { GET_ID_FROM_PAYLOAD } from './Sections/core'
export { STATUS } from './Sections/core'
export { HOST } from './Sections/api'
export { SYSTEM_USER } from './Sections/auth'
export { MERCHANT_USER_ROLE } from './Sections/auth'
export { PRIVILEGE_ATTRIBUTE } from './Sections/auth'
export { TWO_FACTOR_LOGIN_METHOD } from './Sections/auth'
export { STAFF_ROLE } from './Sections/auth'
export { RESTAURANT_URL_TYPE } from './Sections/types'
export { SELECT_CATEGORY_TYPE } from './Sections/types'
export { CONTACT_US_MESSAGE_TYPE } from './Sections/types'
export { REDEEM_GROUP } from './Sections/types'
export { PRODUCT_TYPE } from './Sections/types'
export { URL_MAP_ACTION_TYPE } from './Sections/types'
export { QUEUE_CAMPAIGN_TYPE } from './Sections/types'
export { TNC_TYPE } from './Sections/types'
export { EMAIL_TEMPLATE_TYPE } from './Sections/types'
export { TABLE_TYPE_DEFAULT_VALUE } from './Sections/types'
export { RESERVATION_TABLE_TYPE_LIST_INPUT } from './Sections/types'
export { QUEUE_TEMPLATE_MAP_TYPE } from './Sections/types'
export { RESERVATION_TEMPLATE_MAP_TYPE } from './Sections/types'
export { MERCHANT_DEVICE_TYPE } from './Sections/types'
export { PRINT_TEMPLATE_TYPE } from './Sections/types'
export { LANDING_ACTION_PARAMETER } from './Sections/landing'
export { LANDING_SECTION_ACTION } from './Sections/landing'
export { LANDING_SECTION_SERVICE_TYPE } from './Sections/landing'
export { LANDING_SECTION_SECTION_TYPE } from './Sections/landing'
export { LANDING_ACTION } from './Sections/landing'
export { LANDING_ITEM_ACTION } from './Sections/landing'
export { LANDING_ITEM_TYPE } from './Sections/landing'
export { BANNER_TYPE } from './Sections/banner'
export { BANNER_ACTION } from './Sections/banner'
export { BANNER_PRODUCT_PARENT } from './Sections/banner'
export { PICTURE_SIZE } from './Sections/media'
export { IMAGE_TYPE } from './Sections/media'
export { UPLOAD_TYPE } from './Sections/media'
export { SLIDESHOW_TYPE } from './Sections/media'
export { SLIDESHOW_VIDEO_FORMAT } from './Sections/media'
export { ENV } from './Sections/env'
